/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What an event is used for.
 * @export
 */
export const WebApiModelsEnumerationTypesEventType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesEventType = typeof WebApiModelsEnumerationTypesEventType[keyof typeof WebApiModelsEnumerationTypesEventType];


export function WebApiModelsEnumerationTypesEventTypeFromJSON(json: any): WebApiModelsEnumerationTypesEventType {
    return WebApiModelsEnumerationTypesEventTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesEventType {
    return json as WebApiModelsEnumerationTypesEventType;
}

export function WebApiModelsEnumerationTypesEventTypeToJSON(value?: WebApiModelsEnumerationTypesEventType | null): any {
    return value as any;
}

